import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import languageData from './traducao.json'; 

function InfoSobrevidas() {
    const navigate = useNavigate(); 
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem("siteLanguage") || 'pt'); 

    useEffect(() => {
        const browserLanguage = navigator.language.split('-')[0]; 
        const supportedLanguages = ['pt', 'en', 'es'];

        if (!localStorage.getItem("siteLanguage")) {
            if (supportedLanguages.includes(browserLanguage)) {
                setCurrentLanguage(browserLanguage);
                localStorage.setItem("siteLanguage", browserLanguage);
            } else {
                setCurrentLanguage('pt');
                localStorage.setItem("siteLanguage", 'pt');
            }
        }
    }, []);

    const handleClick = () => {
        navigate("/proposito"); 
        window.scrollTo(0, 0); 
    };

    const translations = languageData[currentLanguage];

    return (
        <>
            <div
                className="flex flex-col bg-[#6A0DAD] min-h-[27em] items-center mb-[3%] max-[1024px]:p-[80px] max-[1024px]:mb-[10%]"
            >
                <div
                    className="mt-[4%] border-l-[10px] border-[#FF8989] pl-[30px] text-left mx-[25%] mb-[3vw] max-[1024px]:mx-[-5%] max-[1024px]:mb-[10vw] max-[748px]:mx-[-15%] max-[748px]:mb-[10vw]"
                >
                    <p className="text-[#FF8989] text-[4.5vh] font-extrabold max-[1024px]:text-[32px]">
                        {translations.oQueESobrevidas}
                    </p>
                    <p className="text-white text-[30px] font-normal max-[1024px]:text-[26px] mt-[12px]">
                        {translations.sobrevidasDescricao}
                    </p>
                </div>
                <div
                    className="ml-[-20px] rounded-[10px] bg-white w-[15em] h-[2.5em] text-[#353535] font-bold text-[20px] flex justify-center items-center hover:text-white hover:bg-[#B040B1] max-[1024px]:w-[12em]"
                    onClick={handleClick}
                    style={{ cursor: 'pointer' }}
                >
                    <p>{translations.nossoProposito}</p>
                </div>
            </div>
        </>
    );
}

export default InfoSobrevidas;
